import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    CloudUploadOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    PictureOutlined,
    RightOutlined,
} from '@ant-design/icons';
import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Image,
    Input,
    Modal,
    Row,
    Select,
    Tabs,
    Upload,
    message,
} from 'antd';
import { getResultCompanyById } from 'api/MasterData/company';
import { getResultOperation } from 'api/MasterData/operation';
import { getResultSubOperation } from 'api/MasterData/subOperation';
import {
    deleteEventChangeCompany,
    getFileDoc,
    getProjectById,
    projectEdit,
    saveImage,
} from 'api/Project/project';
import { getCookie, setCookie } from 'helper/cookie';
import { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import ellipse from '../../../icons/Ellipse1.svg';

import {
    GET_COMPANY_POWERBI_NEW,
    GET_IMPACTTYPE,
    GET_PROJECT_CATEGORY,
    GET_PROJECT_GROUP_V2
} from 'api/Admin/powerbi';
import { getCompanyReportV2 } from 'api/Dashboard/company_report';
import { getResultCompanyHoliday } from 'api/MasterData/companyHoliday';
import { getResultDuration } from 'api/MasterData/duration';
import { getCompanyLink } from 'api/MasterData/userManagement';
import { getFileSecurityFromApi } from 'api/OpenFile';
import { deleteFile } from 'api/Project/project';
import { checkCompleteFlow, getFlowCheckDate } from 'api/Project/sprintFlow';
import Document from 'common/Upload/Document';
import ListFile from 'common/Upload/Listfile';
import TreeSelectOperation from 'components/Management/Tree/PowerBI/OperationTree';
import TreeSelectOperationEdit from 'components/Management/Tree/PowerBI/OperationTree_New';
import TreeSelectSubOperation from 'components/Management/Tree/PowerBI/SuboperationTree';
import TreeSelectSubOperationEdit from 'components/Management/Tree/PowerBI/SuboperationTree_New';
import TreeSelectImpactType from 'components/Management/Tree/PowerBI/impactType';
import TreeSelectProjectCategory from 'components/Management/Tree/PowerBI/projectCategory';
import TreeSelectProjectGroup from 'components/Management/Tree/PowerBI/projectGroup';
import lang from 'lang/en';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { useHistory, useLocation } from 'react-router-dom';
import { ShimmerButton, ShimmerCircularImage, ShimmerTitle } from 'react-shimmer-effects';
import { CounterContext } from 'redux/Golbalvalues';
import 'styleLess/signature/information.scss';
import AdditionalBusiness from '../components/AdditionalBusiness';
import './index.scss';

const EditUpload = styled(Upload)``
const Container = styled.div`
  .font-title-modal {
    font-size: 30px;
  }
`

const { TextArea } = Input
const { Option } = Select
const isActiveStatus = (item) => String(item?.status || '').toLowerCase() === 'active'

const filterActiveTree = (nodes = []) => {
  return (nodes || [])
    .filter((node) => isActiveStatus(node))
    .map((node) => {
      const children = Array.isArray(node.children)
        ? filterActiveTree(node.children)
        : node.children

      return {
        ...node,
        children: Array.isArray(node.children) ? children : node.children,
      }
    })
}

const initalState = {
  data: [],
  isLoading: true,
  isLoadingMultiForm: {
    information: false,
    file: false,
    company: false,
    operation: false,
    suboperation: false,
    projectgroup: false,
    projectcategory: false,
    impacttype: false,
    holiday: false,
    duration: false,
    kickOff: false,
    closure: false,
  },
}

const Information = (props) => {
  const {
    swithCaseFunction,
    role,
    idEditPRJ,
    statusProject,
    form,
    switchStep,
    setFocusPage,
    setCheckBtn,
    checkBtn,
    setVisibleSaveDraft,
    setDirty,
    click_path,
    setClick_path,
    setPermissionBtnStatus,
    fullyCheckComplete,
    statusId,
  } = props

  const { mainRoleUser } = useContext(CounterContext)
  console.log('mainRoleUser', mainRoleUser)
  const eventCopy = useLocation().state

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [optionCompany, setOptionCompany] = useState([])
  const [optionCompany_active, setOptionCompanyActive] = useState([])
  const [disabledCompany, setDisabledCompany] = useState(false)
  const [isLoadingMultiForm, setIsLoadingMultiForm] = useState(
    initalState.isLoadingMultiForm,
  )

  const [oldCompanyID, setOldCompanyID] = useState(0)
  const [visibilityDeleteModalavatar, setVisibilityDeleteModalavatar] = useState(false)
  const [skipModal, setSkipModal] = useState(false)
  const [visibleConfirmSave, setVisibleConfirmSave] = useState(false)
  const [visibleConfirmCompany, setVisibleConfirmCompany] = useState(false)

  const [dataProjectGroup, setDataProjectGroup] = useState(initalState.data)
  const [dataProjectCategory, setDataProjectCategory] = useState(initalState.data)
  const [dataImpactType, setDataImpactType] = useState(initalState.data)
  const [dataHoliday, setDataHoliday] = useState(initalState.data)
  const [dataDuration, setDataDuration] = useState(initalState.data)
  const [dataEdit, setDataEdit] = useState(initalState.data)
  const isEditMode = dataEdit?.status_id > 1
  const [state, setState] = useState('')
  const [logoName, setlogoName] = useState('')
  const [kickOff, setKickOff] = useState('')
  const [closure, setClosure] = useState('')

  const [visibleSubOperation, setVisibleSubOperation] = useState(true)
  const [visibleProjectGroup, setVisibleProjectGroup] = useState(true)
  const [visibleProjectCategory, setVisibleProjectCategory] = useState(true)
  const [visibleImpactType, setVisibleImpactType] = useState(true)
  const [visibleHoliday, setVisibleHoliday] = useState(true)
  const [dataOperation, setDataOperation] = useState(initalState.data)
  const [dataSubOperation, setDataSubOperation] = useState(initalState.data)
  const [listFileDoc, setListFileDoc] = useState(initalState.data)
  const [avatarID, setAvatarID] = useState()
  const [operID, setOperID] = useState()
  const [checkDate, setCheckDate] = useState(false)
  const token = getCookie('access_token_admin')
  const default_companyId = getCookie('ProfessSK_comID')
  const language = getCookie('lang')
  const history = useHistory()
  let id_create = getCookie('idPRJ')
  const word = lang[language]
  const pathURL = window.location.pathname

  const [masterData, setMasterData] = useState([])
  const [masterData_edit, setMasterDataEdit] = useState([])
  const [masterDataProjectGroup, setMasterDataProjectGroup] = useState([])
  const [masterDataImpactType, setMasterDataImpactType] = useState([])
  // map id->name สำหรับ inactive items ตอน edit
  const [selectedProjectGroupNameMap, setSelectedProjectGroupNameMap] = useState({})
  const [selectedProjectCategoryNameMap, setSelectedProjectCategoryNameMap] = useState({})
  const [selectedImpactTypeNameMap, setSelectedImpactTypeNameMap] = useState({})
  const [choiceOperation, setChoiceOperation] = useState([])
  const [choiceSubOperation, setChoiceSubOperation] = useState([])
  const [choiceProjectCategory, setChoiceProjectCategory] = useState([])
  const [choiceProjectGroup, setChoiceProjectGroup] = useState([])
  const [choiceImpactType, setChoiceImpactType] = useState([])
  const [choiceImpactTypeInactive, setChoiceImpactTypeInactive] = useState([])
  const [accountOptions, setAccountOptions] = useState([])
  const [choiceCompany, setChoiceCompany] = useState([])
  const [type, setType] = useState(1)
  let url_page = window.location.pathname
  const setFieldsValueWhenEditProject = async (data) => {
    const operationMap = data?.operation_code.map((e) => e?.id?.toString())
    const subOperationnMap = data?.suboperation_code.map((e) => e?.id?.toString())
    const projectGroupMap = data?.project_group_code.map((e) => e?.id?.toString())
    const projectCategoryMap = data?.subproject_group_code.map((e) => e?.id?.toString())
    const projectImpactTypeCodeMap = data?.impact_type_code.map((e) => e?.id?.toString())
    const projectImpactTypeInactiveMap = data?.impact_type_code.filter(
      (item) => item.id !== 0,
    )

    // สร้าง name map สำหรับ inactive items: { "id": "name" }
    const groupNameMap = {}
    data?.project_group_code?.forEach((e) => {
      groupNameMap[e?.id?.toString()] = e?.name_en || e?.name || e?.id?.toString()
    })
    setSelectedProjectGroupNameMap(groupNameMap)

    const categoryNameMap = {}
    data?.subproject_group_code?.forEach((e) => {
      categoryNameMap[e?.id?.toString()] = e?.name_en || e?.name || e?.id?.toString()
    })
    setSelectedProjectCategoryNameMap(categoryNameMap)

    const impactTypeNameMap = {}
    data?.impact_type_code?.forEach((e) => {
      impactTypeNameMap[e?.id?.toString()] = e?.name_en || e?.name_th || e?.id?.toString()
    })
    setSelectedImpactTypeNameMap(impactTypeNameMap)

    setChoiceOperation(operationMap)
    setChoiceSubOperation(subOperationnMap)
    setChoiceProjectGroup(projectGroupMap)
    setChoiceProjectCategory(projectCategoryMap)
    setChoiceImpactType(projectImpactTypeCodeMap)
    setChoiceImpactTypeInactive(projectImpactTypeInactiveMap)

    // additional business on edit
    const projectCompaniesData = data?.project_companies

    if (projectCompaniesData?.length > 0) {
      const newItems = []
      const newSelectedAdditionalBusiness = []

      projectCompaniesData.forEach((e) => {
        const newActiveKey = `newTab${newTabIndex.current++}`
        const newId = uuidv4()

        newItems.push({
          id: newId,
          label: `Additional Business`,
          key: newActiveKey,
        })

        const companyID = e.company_id.toString()
        const operationsMap = e.operation_code.map((operation) => operation.id.toString())
        const subOperationsMap = e.suboperation_code.map((suboperation) =>
          suboperation.id.toString(),
        )
        const projectGroupsMap = e.project_group_code.map((group) => group.id.toString())
        const projectCategoriesMap = e.subproject_group_code.map((category) =>
          category.id.toString(),
        )
        const projectImpactTypesCodeMap = e.impact_type_code.map((impactType) =>
          impactType.id.toString(),
        )

        newSelectedAdditionalBusiness.push({
          id: newId,
          company_id: companyID,
          operation_id: operationsMap.toString(),
          suboperation_id: subOperationsMap.toString(),
          project_group: projectGroupsMap.toString(),
          subproject_group: projectCategoriesMap.toString(),
          impact_type: projectImpactTypesCodeMap.toString(),
        })
      })

      setItems(newItems)
      setSelectedAdditionalBusiness(newSelectedAdditionalBusiness)
    }

    form.setFieldsValue({
      project_company: data?.company_id,
      project_name: data?.name,
      project_description: data?.description,
      project_goal: data?.goal,
      operation: operationMap,
      suboperation: subOperationnMap,
      project_group: projectGroupMap,
      project_category: projectCategoryMap,
      project_img_type: projectImpactTypeCodeMap,
      project_company_holidays:
        data?.company_holiday_id === 0 ? undefined : data?.company_holiday_id,
      project_duration: data?.duration_id,
      kick_off: moment(`${data?.kickoff}`, 'YYYY-MM-DD'),
      planned_closured: moment(`${data?.closure}`, 'YYYY-MM-DD'),
    })
    const checkCopyProject = eventCopy?.event_copy || false
    if (!checkCopyProject) {
      setDisabledCompany(true) // disabled when edit ticket
    }

    setCheckDate(true)
    setKickOff(data.kickoff)
    setClosure(data.closure)
  }

  const disableInputForStatusWaitingforapprove = [12, 1].includes(Number(mainRoleUser))
    ? false
    : [3, 5, 7, 9, 19, 21, 28, 8].includes(statusId)

  //api dataProjectById
  const getResultListCompanyBI = async () => {
    setIsLoadingMultiForm((prev) => ({ ...prev, operation: true }))
    setIsLoadingMultiForm((prev) => ({ ...prev, suboperation: true }))
    await GET_COMPANY_POWERBI_NEW({
      token: token,
      status: 'all',
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          setMasterDataEdit(data)
          setMasterData(filterActiveTree(data))
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getResultListImpactType = async (companyIds = []) => {
    const normalizedCompanyIds = Array.isArray(companyIds)
      ? companyIds
      : String(companyIds).split(',').filter(Boolean)
    setIsLoadingMultiForm((prev) => ({ ...prev, impacttype: true }))
    await GET_IMPACTTYPE(token, normalizedCompanyIds)
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          setMasterDataImpactType(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const blobUrl = async (path) => {
    const response = await getFileSecurityFromApi({ url: path, token: token })
    return URL.createObjectURL(response.data)
  }

  const getListDataProjectById = async () => {
    await getProjectById({
      id: idEditPRJ ? idEditPRJ : id_create,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataEdit([])
          return true
        }

        if (status === 200) {
          setOperID(data.operation_id)
          setDataEdit(data)
          if (data.logo != null) {
            setAvatarID(data.logo[0].id)
          } else {
            setState({
              imageUrl: null,
            })
          }

          if (data.logo) {
            const newPict = await blobUrl(data.logo[0].urlfile)
            //console.log(data.logo)
            //let nameUrlfile = data.logo[0].urlfile.split('/')
            //let logoname = nameUrlfile[nameUrlfile.length - 1]
            const logoname = data.logo[0].filename
            setlogoName(logoname)
            setState({
              imageUrl: newPict,
            })
          }
          if (data.status_id > 1) {
            // ถ้าไม่ใช่ init ? init คือการสร้างใหม่
            setOldCompanyID(data.company_id)
            await controllerGetCompanyList({
              companyIDofProject: data.company_id,
            })
            await fetchOperationV2({ companyID: data.company_id })
            await fetchSubOperationV2({ operID: data.operation_id })
            // fetch group ก่อน แล้วค่อย fetch category ตามลำดับ
            await fetchProjectGroupV2({ companyID: data.company_id })
            await fetchProjectCategoryV2({
              companyID: data.company_id,
              projectgroupID: data.project_group_id,
            })
            await fetchImpactypeV2({ companyID: data.company_id })
            await fetchHolidayV2({
              companyID: data.company_id,
              operID: data.operation_id,
              subID: data.suboperation_id,
            })
            await getResultListCompanyBI()
            await getResultListImpactType([data.company_id])
            await setFieldsValueWhenEditProject(data)
            // setVisibleOperation(false)
            setVisibleSubOperation(false)
            setVisibleProjectGroup(false)
            setVisibleProjectCategory(false)
            setVisibleImpactType(false)
            setVisibleHoliday(false)
          } else {
            form.setFieldsValue({
              project_name: undefined,
              project_description: undefined,
              project_goal: undefined,
              operation: undefined,
              suboperation: undefined,
              project_group: undefined,
              project_category: undefined,
              project_img_type: undefined,
              project_company_holidays: undefined,
              project_duration: 2,
              kick_off: undefined,
              planned_closured: undefined,
            })
            controllerGetCompanyList({
              companyIDofProject: 'when-createticket',
            })
          }
        } else {
          setDataEdit([])
          return true
        }
      })
      .catch((error) => {
        setDataEdit([])
        console.error(error)
      })
  }
  const controllerGetCompanyList = async (isProps) => {
    setIsLoadingMultiForm((prev) => ({ ...prev, company: true }))
    const { companyIDofProject } = isProps
    let mergedCompanyOptions = []
    if (Number(mainRoleUser) === 1) {
      //admin only
      await getCompanyReportV2({
        pathURL: '/core/company?level=1&status=all',
        token: token,
      })
        .then(async (response) => {
          const { data } = response
          const companyList = Array.isArray(data) ? data : []
          const mappingOptionCompany = companyList?.map((item) => {
            const isActive = String(item?.status || '').toLowerCase() === 'active'
            return {
              value: item.id,
              label: item.name_en || item.name_th,
              status: item?.status,
              isActive,
            }
          })
          const mappingOptionCompanyActive = companyList
            ?.filter((item) => String(item?.status || '').toLowerCase() === 'active')
            .map((item) => {
              return {
                value: item.id,
                label: item.name_en || item.name_th,
                status: item?.status,
                isActive: true,
              }
            })

          mergedCompanyOptions = mappingOptionCompany
          setOptionCompany(mappingOptionCompany)
          setOptionCompanyActive(mappingOptionCompanyActive)
        })
        .catch((err) => err)
    } else {
      const mainCompany = await fetchCompanyByIDV2({
        companyID: default_companyId,
      })
      const ListOfCompanyLink = await fetchCompanyLink({
        userID: getCookie('userID'),
      })
      let joinerCompany = [mainCompany, ...ListOfCompanyLink]

      if (companyIDofProject !== 'when-createticket') {
        const companyofProjectInArray = joinerCompany.find(
          (f) => String(f.value) === String(companyIDofProject),
        )

        if (isEmpty(companyofProjectInArray)) {
          var projectCompanyDefault = await fetchCompanyByIDV2({
            companyID: companyIDofProject,
          })
          joinerCompany = [projectCompanyDefault, ...joinerCompany]
        }
      }
      mergedCompanyOptions = joinerCompany
      setOptionCompany(joinerCompany)
      setOptionCompanyActive(joinerCompany.filter((item) => item?.isActive !== false))
    }

    //ต้อวเป็น case สร้าง โปรเจคใหม่เท่านั้น ถึงจะทำการ default ให้
    const isCreateTicket = companyIDofProject === 'when-createticket'
    const defaultCompanyId = parseInt(default_companyId)
    const projectCompanyId = parseInt(companyIDofProject)
    const defaultCompanyItem = mergedCompanyOptions.find(
      (item) => String(item?.value) === String(defaultCompanyId),
    )
    const shouldSetDefaultCompany =
      !isCreateTicket || defaultCompanyItem?.isActive !== false
    const companyToSet = isCreateTicket
      ? shouldSetDefaultCompany
        ? defaultCompanyId
        : undefined
      : projectCompanyId

    setChoiceCompany(companyToSet ? [String(companyToSet)] : [])
    form.setFieldsValue({
      project_company: companyToSet,
    })

    setIsLoadingMultiForm((prev) => ({ ...prev, company: false }))
    if (isCreateTicket && companyToSet) {
      fetchOperationV2({ companyID: companyToSet })
      fetchProjectGroupV2({ companyID: companyToSet })
      fetchImpactypeV2({ companyID: companyToSet })
      // - 3 fetch ข้างบน มัน fetching ได้เลยเพราะไม่ต้องรอเลือกก่อน มันใช้แค่ company
    }
  }

  const fetchCompanyByIDV2 = async (isProps) => {
    const { companyID } = isProps
    const companyByID = await getResultCompanyById({
      id: companyID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          // setDataCompany([])
          return {}
        }
        if (status === 200) {
          return {
            value: data.main_id,
            label: data.name_en || data.name_th,
            status: data?.status,
            isActive: String(data?.status || '').toLowerCase() === 'active',
          }
        } else {
          return {}
        }
      })
      .catch((error) => {
        console.error(error)
      })
    return companyByID
  }
  const fetchCompanyLink = async (isProps) => {
    const { userID } = isProps
    const list = await getCompanyLink({
      token: token,
      id: userID,
    })
      .then(async (response) => {
        const { status, data, error } = response
        const companyList = Array.isArray(data)
          ? data
          : Array.isArray(data?.result)
            ? data.result
            : []

        if (error) {
          return []
        }
        if (status === 200) {
          return companyList.map((item) => {
            const isActive = item?.status
              ? String(item?.status || '').toLowerCase() === 'active'
              : true
            return {
              value: item.company_id,
              label: item.company_name_en || item.company_name_th,
              status: item?.status,
              isActive,
            }
          })
        } else {
          return []
        }
      })
      .catch((error) => {
        console.error(error)
      })
    return list
  }
  const fetchOperationV2 = async (isProps) => {
    const { companyID } = isProps
    await getResultOperation({
      level_id: companyID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOperation([])
          return true
        }
        if (status === 200) {
          await setDataOperation(data)
        } else {
          setDataOperation([])
          return true
        }
      })
      .catch((error) => {
        setDataOperation([])
        console.error(error)
      })
  }
  const fetchSubOperationV2 = async (isProps) => {
    const { operID } = isProps
    await getResultSubOperation({
      level_id: operID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataSubOperation([])
          return true
        }
        if (status === 200) {
          setDataSubOperation(data)
        } else {
          setDataSubOperation([])
          return true
        }
      })
      .catch((error) => {
        setDataSubOperation([])
        console.error(error)
      })
  }
  const fetchProjectGroupV2 = async (isProps) => {
    const { companyID } = isProps
    if (!companyID) {
      setDataProjectGroup([])
      return
    }
    setIsLoadingMultiForm((prev) => ({ ...prev, projectgroup: true }))
    setDataProjectGroup([])
    const res = await GET_PROJECT_GROUP_V2(token, [companyID])
    setDataProjectGroup(res.error ? [] : res.data)
    setIsLoadingMultiForm((prev) => ({ ...prev, projectgroup: false }))
  }
  const fetchProjectCategoryV2 = async (isProps) => {
    const { companyID, projectgroupID } = isProps
    // projectgroupID อาจเป็น string "1,2" หรือ array
    const groupIds = Array.isArray(projectgroupID)
      ? projectgroupID
      : String(projectgroupID).split(',').filter(Boolean)
    setIsLoadingMultiForm((prev) => ({ ...prev, projectcategory: true }))
    setDataProjectCategory([])
    const res = await GET_PROJECT_CATEGORY(token, [companyID], groupIds)
    const newData = res.error ? [] : res.data
    setDataProjectCategory(newData)
    setIsLoadingMultiForm((prev) => ({ ...prev, projectcategory: false }))
    return newData
  }
  const handleProjectGroupChange = async (value) => {
    setChoiceProjectGroup(value)
    if (!value || value.length === 0) {
      setChoiceProjectCategory([])
      setDataProjectCategory([])
      form.setFieldsValue({ project_category: undefined })
      return
    }
    const companyID = form.getFieldValue('project_company')
    const newCategories = await fetchProjectCategoryV2({
      companyID,
      projectgroupID: value,
    })
    const validIds = new Set(newCategories.map((c) => String(c.id)))
    setChoiceProjectCategory((prev) => {
      const filtered = prev.filter((id) => validIds.has(String(id)))
      form.setFieldsValue({
        project_category: filtered.length > 0 ? filtered : undefined,
      })
      return filtered
    })
  }

  const fetchImpactypeV2 = async (isProps) => {
    const { companyID } = isProps
    setIsLoadingMultiForm((prev) => ({ ...prev, impacttype: true }))
    setDataImpactType([])
    const res = await GET_IMPACTTYPE(token, [companyID])
    const newData = res.error ? [] : res.data
    setDataImpactType(newData)
    setIsLoadingMultiForm((prev) => ({ ...prev, impacttype: false }))
  }
  const fetchHolidayV2 = async (isProps) => {
    setIsLoadingMultiForm((prev) => ({ ...prev, holiday: true }))
    const { companyID, operID, subID } = isProps
    await getResultCompanyHoliday({
      company_id: companyID,
      oper_id: operID,
      sub_id: subID,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataHoliday([])
          return true
        }
        if (status === 200) {
          setDataHoliday(data)
        } else {
          setDataHoliday([])
          return true
        }
      })
      .catch((error) => {
        setDataHoliday([])
        console.error(error)
      })
    setIsLoadingMultiForm((prev) => ({ ...prev, holiday: false }))
  }

  const getDurationlistData = async () => {
    setIsLoadingMultiForm((prev) => ({ ...prev, duration: true }))
    await getResultDuration({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataDuration([])
          return true
        }
        if (status === 200) {
          setDataDuration(data)
        } else {
          setDataDuration([])
          return true
        }
      })
      .catch((error) => {
        setDataDuration([])
        console.error(error)
      })
    setIsLoadingMultiForm((prev) => ({ ...prev, duration: false }))
  }
  // call api file Document
  const getListFileDoc = async () => {
    setIsLoadingMultiForm((prev) => ({ ...prev, file: true }))
    const data = {
      id: idEditPRJ ? idEditPRJ : id_create,
      kind: 14,
    }
    await getFileDoc({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setListFileDoc([])
          return true
        }
        if (status === 200) {
          setListFileDoc(data)
        } else {
          setListFileDoc([])
          return true
        }
      })
      .catch((error) => {
        setListFileDoc([])
        console.error(error)
      })
    setIsLoadingMultiForm((prev) => ({ ...prev, file: false }))
  }

  useEffect(async () => {
    if (token) {
      setIsLoadingMultiForm((prev) => ({
        ...prev,
        company: true,
        information: true,
        operation: true,
        suboperation: true,
        projectgroup: true,
        projectcategory: true,
        impacttype: true,
      }))
      await getDurationlistData()
      await getListDataProjectById()
      await getResultListCompanyBI()
      await getResultListImpactType(default_companyId ? [default_companyId] : [])
      await getListFileDoc()
      await setClick_path()
      setIsLoadingMultiForm((prev) => ({
        ...prev,
        company: false,
        information: false,
        operation: false,
        suboperation: false,
        projectgroup: false,
        projectcategory: false,
        impacttype: false,
      }))
      if (pathURL.includes('create-project')) {
        form.setFieldsValue({
          project_name: '',
          project_description: '',
          project_goal: undefined,
          operation: undefined,
          suboperation: undefined,
          project_group: undefined,
          project_category: undefined,
          project_img_type: undefined,
          project_company_holidays: undefined,
          project_duration: 2,
          kick_off: undefined,
          planned_closured: undefined,
        })
      }
    }
  }, [token])
  const { project_company } = form.getFieldsValue()

  useEffect(async () => {
    await fetchHolidayV2({
      companyID: project_company || '',
      operID: choiceOperation || '',
      subID: choiceSubOperation || '',
    })
  }, [project_company, choiceOperation, choiceSubOperation])

  const controllerFormsetFields = (multiple) => {
    const { action } = multiple
    if (action === 'company') {
      form.setFieldsValue({
        operation: undefined,
        suboperation: undefined,
        project_group: undefined,
        project_category: undefined,
        project_img_type: undefined,
        project_company_holidays: undefined,
      })
    } else if (action === 'operation') {
      form.setFieldsValue({
        suboperation: undefined,
        project_group: undefined,
        project_category: undefined,
        project_img_type: undefined,
        project_company_holidays: undefined,
      })
    } else if (action === 'suboperation') {
      form.setFieldsValue({
        project_group: undefined,
        project_category: undefined,
        project_img_type: undefined,
        project_company_holidays: undefined,
      })
    } else if (action === 'projectgroup') {
      form.setFieldsValue({
        project_category: undefined,
        project_img_type: undefined,
        project_company_holidays: undefined,
      })
    } else if (action === 'category') {
      form.setFieldsValue({
        project_img_type: undefined,
        project_company_holidays: undefined,
      })
    } else if (action === 'impacttype') {
      form.setFieldsValue({
        project_company_holidays: undefined,
      })
    }
  }
  const controllerClearState = (multiple) => {
    const { action } = multiple
    if (action === 'operation') {
      // setFieldByOperation()
      controllerFormsetFields({ action: 'operation' })
      setVisibleSubOperation(true)
      setVisibleProjectGroup(true)
      setVisibleProjectCategory(true)
      setVisibleImpactType(true)
      setVisibleHoliday(true)
    } else if (action === 'suboperation') {
      controllerFormsetFields({ action: 'suboperation' })
      // setFieldBySubOperation()
      setVisibleProjectGroup(true)
      setVisibleProjectCategory(true)
      setVisibleImpactType(true)
      setVisibleHoliday(true)
    } else if (action === 'projectgroup') {
      controllerFormsetFields({ action: 'projectgroup' })
      // setFieldByProjectGroup()
      setVisibleProjectCategory(true)
      setVisibleImpactType(true)
      setVisibleHoliday(true)
    } else if (action === 'category') {
      controllerFormsetFields({ action: 'category' })
      // setFieldByProjectCategory()
      setVisibleImpactType(true)
      setVisibleHoliday(true)
    } else if (action === 'impacttype') {
      controllerFormsetFields({ action: 'impacttype' })
      // setFieldByImpactType()
      setVisibleHoliday(true)
    }
  }

  const controllerOnChange = async (multiple) => {
    const { action, value, dateString } = multiple

    if (action === 'company') {
      if (dataEdit.status_id !== 1) {
        setVisibleConfirmCompany(true)
      } else {
        setCookie('companyId_project', value)
        setDirty(true)
        controllerFormsetFields({ action: 'company' })
        setChoiceOperation([])
        setChoiceSubOperation([])
        setVisibleSubOperation(true)
        setVisibleProjectGroup(true)
        setVisibleProjectCategory(true)
        setVisibleImpactType(true)
        setVisibleHoliday(true)
        const valueBuIdToString = value.toString()
        setChoiceCompany([valueBuIdToString])
        await fetchOperationV2({ companyID: value })
        await fetchImpactypeV2({ companyID: value })
        await fetchProjectGroupV2({ companyID: value })
      }
    } else if (action === 'operation') {
      setDirty(true)
      setOperID(value)
      controllerFormsetFields({ action: 'operation' })

      setVisibleProjectGroup(true)
      setVisibleProjectCategory(true)
      setVisibleImpactType(true)
      setVisibleHoliday(true)

      await fetchSubOperationV2({ operID: value })
      if (value != null) {
        setVisibleSubOperation(false)
      }
    } else if (action === 'suboperation') {
      setDirty(true)
      controllerFormsetFields({ action: 'suboperation' })
      setVisibleProjectCategory(true)
      setVisibleImpactType(true)
      setVisibleHoliday(true)
      if (value != null) {
        setVisibleProjectGroup(false)
      }
      const { project_company, operation } = form.getFieldsValue()
      await fetchHolidayV2({
        companyID: project_company,
        operID: operation,
        subID: value,
      })
    } else if (action === 'projectgroup') {
      setDirty(true)
      controllerFormsetFields({ action: 'projectgroup' })
      // setFieldByProjectGroup()
      setVisibleImpactType(true)
      setVisibleHoliday(true)
      if (value != null) {
        setVisibleProjectCategory(false)
      }
      const { project_company } = form.getFieldsValue()
      await fetchProjectCategoryV2({
        companyID: project_company,
        projectgroupID: value,
      })
    } else if (action === 'category') {
      setDirty(true)
      controllerFormsetFields({ action: 'category' })
      // setFieldByProjectCategory()
      setVisibleHoliday(true)
      if (value != null) {
        setVisibleImpactType(false)
      }
    } else if (action === 'impacttype') {
      setDirty(true)
      controllerFormsetFields({ action: 'impacttype' })
      // setFieldByImpactType()
      if (value != null) {
        setVisibleHoliday(false)
      }
    } else if (action === 'kickoff') {
      setDirty(true)
      // dateKickOffNew = value
      setKickOff(dateString)
    } else if (action === 'closure') {
      setDirty(true)
      // dateClosureNew = value
      setClosure(dateString)
    }
  }

  function disabledDateKickoff(current) {
    // Can not select days before today and today
    if (closure && !kickOff) {
      return (
        (current && current >= moment(closure)) || current <= moment().subtract(1, 'days')
      )
    } else if (kickOff && closure) {
      if (checkDate === true) {
        return (
          (current && current <= moment().subtract(1, 'days')) ||
          current > moment(closure).subtract(1, 'days')
        )
      } else {
        return (
          (current && current <= moment().subtract(1, 'days')) ||
          current > moment(closure).subtract(0, 'days')
        )
      }
    } else {
      return current && current <= moment().subtract(1, 'days')
    }
  }

  function disabledDateClosure(current) {
    if (kickOff && !closure) {
      return current && current <= moment(kickOff).add(1, 'days')
    } else if (kickOff && closure) {
      return current && current <= moment(kickOff)
    } else {
      return current && current <= moment().subtract(1, 'days')
    }
  }
  const disableUpload = () => {
    if (role !== true) {
      return (
        <>
          <CloudUploadOutlined
            className="icons"
            style={{ cursor: role ? 'not-allowed' : 'pointer' }}
          />
          click to upload
        </>
      )
    }
  }
  const shrimer = (type, index) => {
    if (type === 'btn') {
      return (
        <div className="shim-width100">
          <ShimmerButton size="sm" />
        </div>
      )
    } else if (type === 'title') {
      return (
        <div className="title-width250px shimmer-margin-bottom">
          <ShimmerTitle line={1} />
        </div>
      )
    } else if (type === 'select') {
      return (
        <div className="shim-select">
          <ShimmerButton size="sm" />
        </div>
      )
    } else if (type === 'img') {
      return (
        <div className="shimmer-img-margin-right">
          <ShimmerCircularImage size={50} />
        </div>
      )
    }
  }
  const showCardDoc = () => {
    if (listFileDoc.length > 0) {
      return (
        <Card className="card-style" style={{ cursor: role ? 'not-allowed' : 'default' }}>
          <img className="logo-upload" src={ellipse}></img>
          <div className="row-card">
            <div
              style={{ cursor: role ? 'not-allowed' : 'default' }}
              className="text-upload"
            >
              <>{listFileDoc.length} files uploaded</>
            </div>
            <div
              className="text-upload"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsModalVisible(true)}
            >
              {!isLoadingMultiForm.file ? disableUpload() : ''}
            </div>
          </div>
        </Card>
      )
    } else {
      return (
        <Card
          style={{ cursor: role ? 'not-allowed' : 'pointer' }}
          className="card-style"
          onClick={role ? () => setIsModalVisible(false) : () => setIsModalVisible(true)}
        >
          <img className="logo-upload" src={ellipse}></img>
          <div
            style={{ cursor: role ? 'not-allowed' : 'pointer' }}
            className="text-upload"
          >
            <>Click to upload file</>
          </div>
        </Card>
      )
    }
  }
  const [onsaveParams, setOnSaveParams] = useState()
  // console.log(dataEdit)

  const onFinish = async (value) => {
    const copyProject = eventCopy?.event_copy || false
    const before_companyID = dataEdit?.company_id
    const after_companyID = form.getFieldValue('project_company')
    const params = {
      initId: idEditPRJ ? idEditPRJ : id_create,
      name: value?.project_name,
      description: value?.project_description,
      goal: value?.project_goal,
      // dataEdit.status_id === 1 ? parseInt(default_companyId) : dataEdit.company_id,

      company_id: parseInt(value?.project_company),
      operation_id: choiceOperation.toString(),
      suboperation_id: choiceSubOperation.toString(),
      project_group_id: choiceProjectGroup.toString(),
      subproject_group_id: choiceProjectCategory.toString(),
      impact_type_id: choiceImpactType.toString(),

      duration_id: value?.project_duration,
      company_holiday_id: value?.project_company_holidays,
      kickoff: kickOff,
      closure: closure,
      need_approve: 'N',
      // additional business payload
      project_companies: selectedAdditionalBusiness
        ?.filter((item) => item?.company_id !== null)
        ?.map((item) => {
          return {
            company_id: parseInt(item?.company_id),
            operation_id: item?.operation_id,
            suboperation_id: item?.suboperation_id,
            project_group: item?.project_group,
            subproject_group: item?.subproject_group,
            impact_type: item?.impact_type,
          }
        }),
    }
    if ((dataEdit.status_id === 1 || copyProject === true) && skipModal === false) {
      //จังหวะสร้างใหม่ หรือทำการ copy จะให้แสดง modal มายืนยันก่อน
      setVisibleConfirmSave(true) // open modal
      setOnSaveParams(params)
    } else if (
      copyProject === true &&
      skipModal === true &&
      before_companyID !== after_companyID
    ) {
      await dataInProjectWhennotRalate()
      await initProjectAPIUpdate(params)
    } else {
      // ถ้า edit จะทำการ save ได้เลย
      await initProjectAPIUpdate(params)
    }
  }

  const handleClickNext = () => {
    setCheckBtn('next')
    setFocusPage('skill')
  }

  function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
      return false
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
      return false
    }

    // Add filename validation
    const invalidChars = /[\\/:*?"<>|`&%#',;=!]/g
    const hasInvalidChars = invalidChars.test(file.name)
    if (hasInvalidChars) {
      message.error(
        `Filename contains unsupported characters. Use only A–Z, a–z, 0–9, hyphens (-), or underscores (_).`,
      )
      return false
    }

    return true
  }

  const logoUpload = (file) => {
    const data = new FormData()
    data.append('uploadfile', file)
    data.append('project_id', idEditPRJ ? idEditPRJ : id_create)
    data.append('kind', 13) //document

    try {
      saveImage({
        params: data,
        token: token,
      }).then((res) => {
        // setStatusLogo('done')
        if (res.status === 200) {
          setAvatarID(res.data.id)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleChange = (info) => {
    // if (info.file.status === 'uploading') {
    //   return
    // }

    // if (info.file.status === 'error') {
    //   message.error('Upload failed')
    //   return
    // }

    // Only process the file if it passed validation
    if (info.file.originFileObj && beforeUpload(info.file.originFileObj)) {
      getBase64(info.file.originFileObj, (imageUrl) =>
        setState({
          imageUrl,
        }),
      )
      setlogoName(info.file.name)
    }
  }
  const { imageUrl } = state
  const uploadButton = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img className="logo-upload" src={ellipse}></img>
      <EditUpload
        className="avatar-upload-container"
        action={logoUpload}
        name="uploadfile"
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        disabled={role}
      >
        <p className="text-upload">Click to upload image</p>
      </EditUpload>
    </div>
  )

  const initialFormValue = { project_duration: 2 }

  const duration = () => {
    let check
    if (statusProject >= 6) {
      check = true
    } else {
      check = false
    }
    return (
      <Form.Item
        id="project_duration"
        name="project_duration"
        rules={[
          {
            required: true,
            message: word['project_information_Duration'],
          },
        ]}
      >
        {!isLoadingMultiForm.duration ? (
          <Select
            className="responsive-width"
            key="duration"
            id="project_duration_select"
            name="project_duration_select"
            showSearch
            placeholder="Select Duration"
            style={{ width: '434px', marginBottom: '10px' }}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            allowClear
            size="large"
            disabled={role ? role : check}
            onChange={() => setDirty(true)}
            defaultValue={dataDuration.find((item) => item.name === 'Day')?.id}
          >
            {dataDuration.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        ) : (
          shrimer('select')
        )}
      </Form.Item>
    )
  }

  const initProjectAPIUpdate = async (params) => {
    setDirty(false)
    if (params) {
      try {
        await projectEdit({
          params: params,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setCookie(
              'companyId_project',
              res.data.result.status_id === 1
                ? parseInt(default_companyId)
                : res.data.result.company_id,
            )
            // ถ้าคลิก slide bar จะมี click path
            if (click_path) {
              history.push(`${click_path}`)
              setClick_path()
            } else {
              if (checkBtn === 'save') {
                setVisibleSaveDraft(true)
                history.push(`/project/${idEditPRJ ? idEditPRJ : id_create}/information`)
              } else if (checkBtn === 'next') {
                history.push(`/project/${idEditPRJ ? idEditPRJ : id_create}/skill`)
                swithCaseFunction('skill')
              } else {
                switchStep()
              }
            }
            // check flow ว่าโปรเจคสามารถ kick off ได้มั้ย
            getFlowCheckDate({
              project_id: idEditPRJ ? parseInt(idEditPRJ) : parseInt(id_create),
              token: token,
            })
              .then(async (response) => {
                const { status, data, error } = response

                if (error) {
                  return true
                }

                let flowComplete = ''
                if (data.err_check == 'Y' || fullyCheckComplete == 'N') {
                  flowComplete = 'N'
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    flow_complete: false,
                  }))
                } else {
                  setPermissionBtnStatus((prevState) => ({
                    ...prevState,
                    flow_complete: true,
                  }))
                  flowComplete = 'Y'
                }

                const paramObj = {
                  project_id: idEditPRJ ? parseInt(idEditPRJ) : parseInt(id_create),
                  complete_flow: flowComplete,
                }

                try {
                  checkCompleteFlow({
                    params: paramObj,
                    token: token,
                  }).then((response) => {
                    const { status, data, error } = response
                  })
                } catch (error) {
                  console.log(error)
                }
              })
              .catch((error) => {
                console.error(error)
              })

            props.refreshDataProject()
            setCheckBtn('')
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const dataInProjectWhennotRalate = async () => {
    const params = {
      project_id: idEditPRJ ? idEditPRJ : id_create,
    }
    try {
      await deleteEventChangeCompany({
        params: params,
        token: token,
      }).then((response) => {
        const { status } = response
        if (status === 200) {
          setVisibleConfirmSave(false)
          setSkipModal(true)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const onOkConfirmModal = async () => {
    const copyProject = eventCopy?.event_copy || false
    const before_companyID = dataEdit.company_id
    const after_companyID = form.getFieldValue('project_company')
    // console.log(onsaveParams, copyProject)
    if (copyProject === true && before_companyID !== after_companyID) {
      // ทำการเคลีย data ของ support need and kpi ที่ไม่สัมพันธ์กัน
      await dataInProjectWhennotRalate()
      await initProjectAPIUpdate(onsaveParams)
    } else {
      setVisibleConfirmSave(false)
      setSkipModal(true)
      await initProjectAPIUpdate(onsaveParams)
    }
  }

  const onCancelModal = () => {
    setOnSaveParams()
    setVisibleConfirmSave(false)
  }
  const onOkConfirmModalCompany = () => {
    setDirty(true)
    controllerFormsetFields({ action: 'company' })
    setChoiceOperation([])
    setChoiceSubOperation([])
    setChoiceProjectGroup([])
    setChoiceProjectCategory([])
    setVisibleSubOperation(true)
    setVisibleProjectGroup(true)
    setVisibleProjectCategory(true)
    setVisibleImpactType(true)
    setVisibleHoliday(true)
    const ValueCompanyIDonForm = form.getFieldValue('project_company')
    setChoiceCompany([String(ValueCompanyIDonForm)])
    fetchOperationV2({ companyID: ValueCompanyIDonForm })
    fetchImpactypeV2({ companyID: ValueCompanyIDonForm })
    fetchProjectGroupV2({ companyID: ValueCompanyIDonForm })
    setOldCompanyID(ValueCompanyIDonForm)
    setSkipModal(true)
    setVisibleConfirmCompany(false) //close modal
  }
  const onCancelModalCompany = () => {
    setVisibleConfirmCompany(false) //close modal
    form.setFieldsValue({ project_company: oldCompanyID })
  }

  const onCancle_avatar = () => {
    setVisibilityDeleteModalavatar(false)
  }
  const DeleteAvatarFunctional = () => {
    const data = {
      id: avatarID,
      project_id: idEditPRJ ? idEditPRJ : id_create,
      kind: 13,
    }
    try {
      deleteFile({
        params: data,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          getListDataProjectById()
        }
      })
    } catch (error) {
      console.log(error)
    }
    setVisibilityDeleteModalavatar(false)
  }
  const checkReadyInformation = () => {
    if (isLoadingMultiForm) {
      var mapKey = Object.values(isLoadingMultiForm).find((boo) => boo === true)
    }
    return mapKey === true ? true : false
  }

  const RebaseCutterFunctionally = async (from, valueCom, valueOper, valueSub) => {
    const sourceMasterData = isEditMode ? masterData_edit : masterData
    let arrayOperation = []
    let arraySuboperation = []
    if (from === 'from company') {
      sourceMasterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              arrayOperation.push(c.value)
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else if (from === 'from operation') {
      arrayOperation = valueOper
      sourceMasterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else {
      arrayOperation = valueOper
      arraySuboperation = valueSub
    }
  }

  // additional business tabs function
  const initialTabItems = []
  const [visibleModalDelete, setVisibleModalDelete] = useState(false)
  const [targetKeyToDelete, setTargetKeyToDelete] = useState(null)
  const [activeKey, setActiveKey] = useState(initialTabItems[0]?.key)
  const [items, setItems] = useState(initialTabItems)
  const newTabIndex = useRef(0)

  const [selectedAdditionalBusiness, setSelectedAdditionalBusiness] = useState([])
  const companySelectOptions = optionCompany

  const resetDropdownScrollTop = (dropdownClassName) => {
    const setTop = () => {
      const dropdown = document.querySelector(`.${dropdownClassName}`)
      if (!dropdown) return
      const scrollContainer =
        dropdown.querySelector('.rc-virtual-list-holder') ||
        dropdown.querySelector('.rc-virtual-list') ||
        dropdown
      if (scrollContainer) {
        scrollContainer.scrollTop = 0
      }
    }
    requestAnimationFrame(setTop)
    setTimeout(setTop, 50)
  }

  const handleSelectedValuesChange = (id, key, value) => {
    const updatedSelectedAdditionalBusiness = selectedAdditionalBusiness.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [key]: value,
        }
      }
      return item
    })
    setSelectedAdditionalBusiness(updatedSelectedAdditionalBusiness)
  }

  const onChangeTab = (newActiveKey) => {
    setActiveKey(newActiveKey)
  }

  const addNewTab = () => {
    const newId = uuidv4()
    const newActiveKey = `newTab${newTabIndex.current++}`
    const newPanes = [...items]
    newPanes.push({
      id: newId,
      label: `Additional Business`,
      key: newActiveKey,
    })
    setItems(newPanes)
    const newAdditionalBusiness = {
      id: newId,
      company_id: null,
      operation_id: '',
      suboperation_id: '',
      project_group: '',
      subproject_group: '',
      impact_type: '',
    }
    setSelectedAdditionalBusiness((prevState) => [...prevState, newAdditionalBusiness])
    setActiveKey(newActiveKey)
  }

  const removeTab = (targetKey) => {
    let newActiveKey = activeKey
    let lastIndex = -1
    const newPanes = items.filter((item, i) => {
      if (item.key === targetKey) {
        lastIndex = i - 1
      }
      return item.key !== targetKey
    })

    if (newPanes.length === 0) {
      // หากไม่มีแท็บเหลือ ให้ตั้งแท็บที่เหลืออยู่เป็นแท็บที่ตั้งต้น
      newActiveKey = initialTabItems[0]?.key
    } else if (newPanes.length && newActiveKey === targetKey) {
      if (lastIndex >= 0) {
        newActiveKey = newPanes[lastIndex].key
      } else {
        newActiveKey = newPanes[0].key
      }
    }

    const itemIdToDelete = items.find((item) => item.key === targetKey)?.id

    // ลบข้อมูลใน selectedAdditionalBusiness ที่มี itemId เท่ากับ itemIdToDelete
    const newSelectedAdditionalBusiness = selectedAdditionalBusiness.filter(
      (item) => item.id !== itemIdToDelete,
    )
    setSelectedAdditionalBusiness(newSelectedAdditionalBusiness)
    setItems(newPanes)
    setActiveKey(newActiveKey)
  }

  const onEditTab = (targetKey, action) => {
    if (action === 'add') {
      addNewTab()
    } else {
      // setVisibleModalDelete = true เพื่อแสดง modal
      setVisibleModalDelete(true)
      // setTargetKeyToDelete เพื่อให้ใช้ในการลบ
      setTargetKeyToDelete(targetKey)
    }
  }

  //func modal confirm delete
  const handleDeleteTab = () => {
    removeTab(targetKeyToDelete)
    setVisibleModalDelete(false)
    setTargetKeyToDelete(null)
  }

  return (
    <Container className="container disable-page">
      <Helmet>
        <title>Create Project | Information</title>
      </Helmet>
      <div className="header">
        <h2>Project Information</h2>
        <p>Information is required before the project can be executed.</p>
      </div>

      <Form
        form={form}
        // initialValues={form.setFieldsValue({ project_duration: 2 })}
        initialValues={{}}
        className="font"
        onFinish={onFinish}
        onFinishFailed={() => {
          setFocusPage('information')
          setActiveKey('mainTab')
        }}
      >
        <h4 className="label">Avatar (optional)</h4>

        <Form.Item name="img">
          {imageUrl ? (
            <div className="new-content-upload">
              <div className="start-content">
                <div>
                  {/* <img className='img-size' src={imageUrl} alt='avatar'></img> */}
                  <Image className="img-size" src={imageUrl} alt="avatar" />
                </div>
                <div className="middle-content">
                  <div className="mc-l">
                    <p className="title-avatar">{logoName}</p>
                    <CheckCircleOutlined className="icon-checkcircleoutlined" />
                  </div>
                  <EditUpload
                    className="avatar-upload-container"
                    action={logoUpload}
                    name="uploadfile"
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={handleChange}
                    disabled={role}
                  >
                    <span className="small" onChange={handleChange}>
                      Click to Change Image File
                    </span>
                  </EditUpload>
                </div>
              </div>
              <div className="end-content">
                {avatarID ? (
                  <DeleteOutlined
                    hidden={role}
                    onClick={() => setVisibilityDeleteModalavatar(true)}
                    className="icon-delete"
                  />
                ) : (
                  _
                )}
              </div>
            </div>
          ) : (
            <div className="new-content-upload">{uploadButton}</div>
          )}

          <Document
            visible={isModalVisible}
            setVisible={setIsModalVisible}
            idEditPRJ={idEditPRJ ? idEditPRJ : id_create}
            kind={14}
            getListFileDoc={getListFileDoc}
            listFile={listFileDoc}
          />
        </Form.Item>

        <h4 className="label" style={{ display: 'flex', columnGap: '4px' }}>
          Project Name <p style={{ color: 'red' }}>*</p>
        </h4>
        <Form.Item
          label=""
          id="project_name"
          name="project_name"
          rules={[
            {
              whitespace: true,
              required: true,
              message: word['project_information_ProjectName'],
            },
          ]}
        >
          {!isLoadingMultiForm.information ? (
            <Input
              id="project_name_input"
              name="project_name_input"
              style={{
                height: '40px',
                borderRadius: '8px',
                border: '1px solid #E4E7EC',
              }}
              placeholder="Project Name"
              disabled={role}
              // onChange={onChangeProjectName}
              onChange={() => setDirty(true)}
            />
          ) : (
            shrimer('btn')
          )}
        </Form.Item>
        <h4 className="label">Project Description</h4>
        <Form.Item id="project_description" name="project_description">
          {!isLoadingMultiForm.information ? (
            <TextArea
              id="project_description_textArea"
              name="project_description_textArea"
              placeholder="Project Description"
              autoSize={{ minRows: 2, maxRows: 6 }}
              style={{
                height: '50px',
                borderRadius: '5px',
                border: '1px solid #E4E7EC',
              }}
              disabled={role}
              onChange={() => setDirty(true)}
            />
          ) : (
            shrimer('btn')
          )}
        </Form.Item>
        <h4 className="label">Project Goal</h4>
        <Form.Item id="project_goal" name="project_goal">
          {!isLoadingMultiForm.information ? (
            <TextArea
              id="project_goal_textArea"
              name="project_goal_textArea"
              placeholder="Project Goal"
              autoSize={{ minRows: 2, maxRows: 6 }}
              style={{
                height: '50px',
                borderRadius: '5px',
                border: '1px solid #E4E7EC',
              }}
              disabled={role}
              onChange={() => setDirty(true)}
            />
          ) : (
            shrimer('btn')
          )}
        </Form.Item>
        <h4 className="label">Overview Document (optional)</h4>
        <Form.Item name="overview_doc">{showCardDoc()}</Form.Item>
        {!isLoadingMultiForm.information ? (
          <ListFile
            data={listFileDoc}
            kind={14}
            project_id={idEditPRJ ? idEditPRJ : id_create}
            renderData={getListFileDoc}
            checkRole={role}
          ></ListFile>
        ) : (
          ''
        )}
        <Tabs
          style={{ marginTop: '20px' }}
          type="editable-card"
          size="large"
          onChange={onChangeTab}
          activeKey={activeKey}
          onEdit={onEditTab}
          // hideAdd={items.length >= 3}
        >
          <Tabs.TabPane tab="Main Business" key="mainTab" closable={false}>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col className="col-responsive-width-container">
                <h4 className="label">Business</h4>
                <Form.Item
                  id="project_company"
                  name="project_company"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: word['project_information_Company'],
                  //   },
                  // ]}
                >
                  {!isLoadingMultiForm.company ? (
                    <Select
                      onChange={(e) =>
                        controllerOnChange({ action: 'company', value: e })
                      }
                      dropdownClassName="project-main-company-dropdown"
                      onDropdownVisibleChange={(open) => {
                        if (open) {
                          resetDropdownScrollTop('project-main-company-dropdown')
                        }
                      }}
                      // defaultValue={dataEdit ? dataEdit.company_name : undefined}
                      disabled={disabledCompany}
                      id="company"
                      name="company"
                      className="responsive-width"
                      size="large"
                      placeholder="Business"
                      style={{
                        width: '434px',
                        marginBottom: '10px',
                        border: '1px solid #E4E7EC',
                      }}
                    >
                      {companySelectOptions.map((item) => (
                        <Option
                          key={item.value}
                          value={item.value}
                          style={
                            item?.isActive === false ? { display: 'none' } : undefined
                          }
                        >
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
              <Col className="col-responsive-width-container">
                <h4 className="label">Operation</h4>
                {!isLoadingMultiForm.operation ? (
                  <Form.Item
                    className="size-form"
                    id="operation"
                    name="operation"
                    style={{ width: '434px' }}
                  >
                    {isEditMode ? (
                      <TreeSelectOperationEdit
                        RebaseCutterFunctionally={RebaseCutterFunctionally}
                        form={form}
                        setAccountOptions={setAccountOptions}
                        masterData={masterData_edit}
                        selectedOperationData={dataEdit?.operation_code}
                        choiceCompany={choiceCompany}
                        choiceOperation={choiceOperation}
                        choiceSubOperation={choiceSubOperation}
                        setChoiceOperation={setChoiceOperation}
                        setChoiceSubOperation={setChoiceSubOperation}
                        setType={setType}
                        disabled={disableInputForStatusWaitingforapprove}
                      />
                    ) : (
                      <TreeSelectOperation
                        RebaseCutterFunctionally={RebaseCutterFunctionally}
                        form={form}
                        setAccountOptions={setAccountOptions}
                        masterData={masterData}
                        selectedOperationData={dataEdit?.operation_code}
                        choiceCompany={choiceCompany}
                        choiceOperation={choiceOperation}
                        choiceSubOperation={choiceSubOperation}
                        setChoiceOperation={setChoiceOperation}
                        setChoiceSubOperation={setChoiceSubOperation}
                        setType={setType}
                        disabled={disableInputForStatusWaitingforapprove}
                      />
                    )}

                    {/* const [additaionalBu, setAdditaionalBu] = useState([
                  {
                  choiceOperation: [],
                  choiceSubOperation: "",
                  choiceProjectGroup: "",
                  choiceProjectCategory: "",
                  choiceImpactType: "",
                  choiceCompany: "",
                  }
                ]) */}
                  </Form.Item>
                ) : (
                  shrimer('select')
                )}
              </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col className="col-responsive-width-container">
                <h4 className="label">Project type</h4>

                {!isLoadingMultiForm?.suboperation ? (
                  <Form.Item
                    className="size-form"
                    id="suboperation"
                    name="suboperation"
                    // rules={[
                    //   {
                    //     required: !choiceSubOperation?.length >= 1,
                    //     message: word['project_information_SubOperation'],
                    //   },
                    // ]}
                    style={{ width: '434px' }}
                  >
                    {isEditMode ? (
                      <TreeSelectSubOperationEdit
                        RebaseCutterFunctionally={RebaseCutterFunctionally}
                        form={form}
                        setAccountOptions={setAccountOptions}
                        masterData={masterData_edit}
                        selectedSubOperationData={dataEdit?.suboperation_code}
                        choiceCompany={choiceCompany}
                        choiceOperation={choiceOperation}
                        choiceSubOperation={choiceSubOperation}
                        setChoiceSubOperation={setChoiceSubOperation}
                        setType={setType}
                        disabled={disableInputForStatusWaitingforapprove}
                      />
                    ) : (
                      <TreeSelectSubOperation
                        RebaseCutterFunctionally={RebaseCutterFunctionally}
                        form={form}
                        setAccountOptions={setAccountOptions}
                        masterData={masterData}
                        selectedSubOperationData={dataEdit?.suboperation_code}
                        choiceCompany={choiceCompany}
                        choiceOperation={choiceOperation}
                        choiceSubOperation={choiceSubOperation}
                        setChoiceSubOperation={setChoiceSubOperation}
                        setType={setType}
                        disabled={disableInputForStatusWaitingforapprove}
                      />
                    )}
                  </Form.Item>
                ) : (
                  shrimer('select')
                )}
              </Col>
              <Col className="col-responsive-width-container">
                <h4 className="label">Project Group</h4>
                <Form.Item
                  id="project_group"
                  name="project_group"
                  // rules={[
                  //   {
                  //     required: !choiceProjectGroup?.length >= 1,
                  //     message: word['project_information_Projectgroup'],
                  //   },
                  // ]}
                  style={{ width: '434px' }}
                >
                  {!isLoadingMultiForm.projectgroup ? (
                    <TreeSelectProjectGroup
                      form={form}
                      data={dataProjectGroup}
                      selectedNameMap={selectedProjectGroupNameMap}
                      choiceCompany={choiceCompany}
                      choiceProjectGroup={choiceProjectGroup}
                      setChoiceProjectGroup={handleProjectGroupChange}
                      setChoiceProjectCategory={setChoiceProjectCategory}
                      disabled={disableInputForStatusWaitingforapprove}
                    />
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col className="col-responsive-width-container">
                <h4 className="label">Strategic Direction</h4>
                <Form.Item
                  id="project_category"
                  name="project_category"
                  // rules={[
                  //   {
                  //     required: !choiceProjectCategory.length >= 1,
                  //     message: word['project_information_ProjectCategory'],
                  //   },
                  // ]}
                  style={{ width: '434px' }}
                >
                  {!isLoadingMultiForm.projectcategory ? (
                    <TreeSelectProjectCategory
                      RebaseCutterFunctionally={RebaseCutterFunctionally}
                      form={form}
                      setAccountOptions={setAccountOptions}
                      data={dataProjectCategory}
                      selectedNameMap={selectedProjectCategoryNameMap}
                      choiceCompany={choiceCompany}
                      choiceProjectGroup={choiceProjectGroup}
                      choiceProjectCategory={choiceProjectCategory}
                      setChoiceProjectCategory={setChoiceProjectCategory}
                      setType={setType}
                      disabled={disableInputForStatusWaitingforapprove}
                    />
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
              <Col className="col-responsive-width-container">
                <h4 className="label">Impact Type</h4>
                <Form.Item
                  id="project_img_type"
                  name="project_img_type"
                  // rules={[
                  //   {
                  //     required: !choiceImpactType.length >= 1,
                  //     message: word['project_information_ImpactType'],
                  //   },
                  // ]}
                  style={{ width: '434px' }}
                >
                  {!isLoadingMultiForm.impacttype ? (
                    <TreeSelectImpactType
                      data={dataImpactType}
                      selectedNameMap={selectedImpactTypeNameMap}
                      choiceCompany={choiceCompany}
                      choiceImpactType={choiceImpactType}
                      setChoiceImpactType={setChoiceImpactType}
                      disabled={disableInputForStatusWaitingforapprove}
                    />
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col className="col-responsive-width-container">
                <h4 className="label">Business Holidays</h4>
                <Form.Item
                  id="project_company_holidays"
                  name="project_company_holidays"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: word['project_information_CompanyHolidays'],
                  //   },
                  // ]}
                  style={{ width: '434px' }}
                >
                  {!isLoadingMultiForm.holiday ? (
                    <Select
                      className="responsive-width"
                      key="holidays"
                      id="project_company_holidays_select"
                      name="project_company_holidays_select"
                      disabled={role ? role : project_company === undefined}
                      showSearch
                      placeholder="Select Company Holidays..."
                      style={{
                        width: '434px',
                        marginBottom: '10px',
                        border: '1px solid #E4E7EC',
                      }}
                      optionFilterProp="children"
                      // onChange={onChangeHoliday}
                      onChange={
                        () => setDirty(true) // อัปเดต state ว่ามีการเปลี่ยนแปลง
                      }
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      allowClear
                      size="large"
                    >
                      {dataHoliday.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
              <Col className="col-responsive-width-container">
                <h4 className="label" style={{ display: 'flex', columnGap: '4px' }}>
                  Duration <p style={{ color: 'red' }}>*</p>
                </h4>
                {duration()}
              </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col className="col-responsive-width-container">
                <h4 className="label" style={{ display: 'flex', columnGap: '4px' }}>
                  Kick off Date <p style={{ color: 'red' }}>*</p>
                </h4>
                <Form.Item
                  id="kick_off"
                  name="kick_off"
                  rules={[
                    {
                      required: true,
                      message: word['project_information_Kick_off_date'],
                    },
                  ]}
                >
                  {!isLoadingMultiForm.kickOff ? (
                    <DatePicker
                      className="responsive-width"
                      id="kick_off_date"
                      name="kick_off_date"
                      onChange={(e, a) =>
                        controllerOnChange({
                          action: 'kickoff',
                          value: e,
                          dateString: a,
                        })
                      }
                      // onChange={onChangeKickOff}
                      style={{
                        width: '434px',
                        marginBottom: '10px',
                        border: '1px solid #E4E7EC',
                      }}
                      format="YYYY-MM-DD"
                      size="large"
                      disabledDate={disabledDateKickoff()}
                      disabled={role}
                    />
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
              <Col className="col-responsive-width-container">
                <h4 className="label" style={{ display: 'flex', columnGap: '4px' }}>
                  Planned Closures Date <p style={{ color: 'red' }}>*</p>
                </h4>
                <Form.Item
                  id="planned_closured"
                  name="planned_closured"
                  rules={[
                    {
                      required: true,
                      message: word['project_information_Planned_Closured_Date'],
                    },
                  ]}
                >
                  {!isLoadingMultiForm.closure ? (
                    <DatePicker
                      className="responsive-width"
                      id="planned_closured_date"
                      name="planned_closured_date"
                      onChange={(e, a) =>
                        controllerOnChange({
                          action: 'closure',
                          value: e,
                          dateString: a,
                        })
                      }
                      // onChange={onChangeclosure}
                      style={{
                        width: '434px',
                        marginBottom: '10px',
                        border: '1px solid #E4E7EC',
                      }}
                      format="YYYY-MM-DD"
                      size="large"
                      disabledDate={disabledDateClosure}
                      disabled={role}
                    />
                  ) : (
                    shrimer('select')
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Tabs.TabPane>
          {items?.map((item, index) => (
            <Tabs.TabPane tab={item.label} key={item.key} closable={item.closable}>
              <AdditionalBusiness
                additionalId={item.id}
                masterData={masterData}
                masterDataEdit={masterData_edit}
                isEditMode={isEditMode}
                masterDataImpactType={masterDataImpactType}
                masterDataProjectGroup={masterDataProjectGroup}
                isLoadingMultiForm={isLoadingMultiForm}
                dataSelected={selectedAdditionalBusiness[index]}
                optionCompany={isEditMode ? optionCompany : optionCompany_active}
                optionCompanyActive={optionCompany_active}
                setSelected={(e) =>
                  handleSelectedValuesChange(item.id, e.action, e.value)
                }
                tabCompanyData={dataEdit?.project_companies?.[index]}
              />
            </Tabs.TabPane>
          ))}
        </Tabs>

        <Row justify="end">
          <Button
            style={{ visibility: checkReadyInformation() ? 'hidden' : '' }}
            id="nextinformation"
            htmlType="submit"
            className="BTN_Next"
            onClick={handleClickNext}
          >
            Next
            <RightOutlined className="Icon-color" />
          </Button>
        </Row>
      </Form>
      <Modal
        className="modal-delete-avatar"
        visible={visibilityDeleteModalavatar}
        onOk={DeleteAvatarFunctional}
        onCancel={onCancle_avatar}
        okText={'Delete'}
      >
        <PictureOutlined className="icon-pictureOutlined" />
        <h2>Delete Avatar</h2>
        <h4>Are you sure you want to delete avatar</h4>
      </Modal>
      <Modal
        className="edit-width-skill"
        visible={visibleConfirmSave}
        onOk={onOkConfirmModal}
        onCancel={onCancelModal}
        centered
        okText="Confirm"
      >
        {' '}
        <div className="body-modal">
          <InfoCircleOutlined className="Icon-style" />
          <h2 style={{ textAlign: 'center' }}>Confirm Save</h2>
          <h4 style={{ textAlign: 'center' }}>
            Saving a project cannot modify the Business
          </h4>
        </div>
      </Modal>
      <Modal
        className="edit-width-skill"
        visible={visibleConfirmCompany}
        onOk={onOkConfirmModalCompany}
        onCancel={onCancelModalCompany}
        centered
        okText="Confirm"
      >
        {' '}
        <div className="body-modal">
          <InfoCircleOutlined className="Icon-style" />
          <h2 style={{ textAlign: 'center' }}>Confirm Business</h2>
          <h4 style={{ textAlign: 'center' }}>
            Saving a project cannot modify the Business and all data (KPI and Support
            need) related to original Business will be deleted.
          </h4>
        </div>
      </Modal>

      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleModalDelete}
        okText={'Delete'}
        onOk={() => handleDeleteTab()}
        onCancel={() => setVisibleModalDelete(false)}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word['delete_file_select_title']}</h2>
        <h4>{word['delete_file_select_des']}</h4>
      </Modal>
    </Container>
  )
}
export default Information
